import * as $ from "jquery";
import { Component, OnInit } from '@angular/core';
import { PrivacyService } from '../privacy/privacy.service';
import { dataResponse } from './widget.model';
import { constants } from '../constants';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

interface UserData {
  documentId:string,
  documentType:string,
  phone:string
}

@Component({
  selector: 'app-wigdet-personal-data',
  templateUrl: './wigdet-personal-data.component.html',
  styleUrls: []
})
export class WigdetPersonalDataComponent implements OnInit {

  linkWidget:string = ""
  iframeUrl:SafeResourceUrl 
  modalTitle:string = ""
  modalContent:string = ""

  isShowModal:boolean = false
  canChargeForm:boolean = false
  
  userData: UserData

  widthIframe:number = 0
  heightIframe:number = 0
  countHeight:number = 0
  constructor(private privacyService:PrivacyService,private domSanitizer: DomSanitizer) { }

  ngOnInit() {
    this.getUrlWidget()
    this.userData = JSON.parse(localStorage.getItem("userData"))
    window.addEventListener("resize", this.setOptionPosition);
  }

  getUrlWidget(){
    this.privacyService.getGroupParameters("WS_WIDGET_ARSO").subscribe((dataResponse:dataResponse)=>{
      if (dataResponse.responseCode == "00") {
        if(dataResponse['responseCode'] ==  constants.SUCCESS_WS_RESPONSE_CODE){
          this.linkWidget = dataResponse.obj[0].value
          this.iframeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
            this.linkWidget+"?brand=MAXIplus&id="+this.userData.documentId+
            "&documentType="+this.userData.documentType+"&chanel=WEB"+
            "&phoneNumber="+this.userData.phone
          );
          this.canChargeForm = true
          setTimeout( () => {
            this.setOptionPosition()
          }, 2500)
        }else{
          this.modalTitle = "Error: ";
          this.modalContent =  "No se ha podido establecer la conexión con el servidor.";
          this.isShowModal = true;
        }
      }
    },
    (err) => {
      this.modalTitle = "Error: " + err.code;
      this.modalContent =  "No se ha podido establecer la conexión con el servidor.";
      this.isShowModal = true;
    })
  }
  setOptionPosition(){
    this.widthIframe = $("iframe").width();
    this.heightIframe = $("iframe").height();
  
    var positionX = this.widthIframe * .5
    // var positionY = this.heightIframe * .1
  
    $('#labelInfo').css('display', 'block')
    $('#labelInfo').css('margin-left', positionX - 310)
    this.widthIframe < 1200 ?  $('#labelInfo').css('margin-top',  "-13%" ):
                              $('#labelInfo').css('margin-top',  "-8%" )
   } 
}
